<template>
  <div id="app" class="enter-dom">
    <router-view v-if="isRouterAlive"/>
    <canvas class="canvas-self-view" id="canvas-wms" :width="videoSize.width" :height="videoSize.height"></canvas>
  </div>
</template>

<script>
  import Vue from "vue";
  import {videoSize} from "./api/getData";

  export default {
    name: "App",
    provide() {
      return {
        reload: this.reload,
      };
    },
    data() {
      return {
        isRouterAlive: true,
        originUserId:"",
        videoSize:videoSize
      };
    },
    methods: {
      reload() {
        this.isRouterAlive = false;
        this.$nextTick(function () {
          this.isRouterAlive = true;
        });
      }
    }, mounted: function () {
      //这个方法是监测浏览器窗口发生变化的时候执行
      window.addEventListener("visibilitychange", function (res) {
        let msgLocal = Vue.prototype.localCache.msg;
        if (!msgLocal){
          location.href = location.origin
          location.reload();
        }else if (!this.originUserId){
          this.originUserId = msgLocal.userId;
        }else if (this.originUserId !== msgLocal.userId) {
          this.originUserId = msgLocal.userId;
          alert("检测您已经切换账户")
          location.reload();
        }
      })
      // let that = this;
      // this.$goEasy.subscribe({
      //   channel: "my_channel", //替换为您自己的channel
      //   onMessage: function (message) {
      //     that.$notify.info({
      //       title: message.channel,
      //       message: message.content
      //     });
      //   }
      // });
    }
  };
</script>

<style>
  #app {
    font-family: "Avenir", Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    /* text-align: center; */
    color: #2c3e50;
    /* margin-top: 60px; */
  }

  .enter-dom {
    height: 100%;
    overflow-y: hidden;
  }

  .canvas-self-view{
    position: fixed;
    left: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue